(function() {
  'use strict';

  window.addEventListener('load', function() {
    setTimeout(function() {
      document.getElementById('loadVeil').classList.add('hidden');
    }, 1800);
  });

  // --- CANVAS NOISE ---
  var nc = document.getElementById('noiseCanvas');
  var ctx = nc.getContext('2d');
  var nw, nh;
  function resizeN() {
    nw = Math.floor(window.innerWidth / 4);
    nh = Math.floor(window.innerHeight / 4);
    nc.width = nw; nc.height = nh;
  }
  resizeN();
  window.addEventListener('resize', resizeN);

  var nf = 0;
  function noiseLoop() {
    if (++nf % 3 === 0) {
      var d = ctx.createImageData(nw, nh), p = d.data;
      for (var i = 0; i < p.length; i += 4) {
        var v = Math.random() * 255;
        p[i] = v; p[i+1] = v; p[i+2] = v; p[i+3] = 255;
      }
      ctx.putImageData(d, 0, 0);
    }
    requestAnimationFrame(noiseLoop);
  }
  requestAnimationFrame(noiseLoop);

  // --- MOUSE ---
  var mx = window.innerWidth/2, my = window.innerHeight/2, tx = mx, ty = my;
  document.addEventListener('mousemove', function(e) { tx = e.clientX; ty = e.clientY; });

  var stage = document.getElementById('logoStage');
  var df = document.getElementById('distortionField');

  function mLoop() {
    mx += (tx - mx) * 0.06;
    my += (ty - my) * 0.06;
    var dx = (mx - window.innerWidth/2) / (window.innerWidth/2);
    var dy = (my - window.innerHeight/2) / (window.innerHeight/2);
    stage.style.transform = 'translate(calc(-50% + ' + (dx*6) + 'px), calc(-50% + ' + (dy*4) + 'px))';
    df.style.left = mx + 'px';
    df.style.top = my + 'px';
    df.style.opacity = '0.3';
    requestAnimationFrame(mLoop);
  }
  requestAnimationFrame(mLoop);
  document.addEventListener('mouseleave', function() { df.style.opacity = '0'; });

  // --- SCAN LINE ---
  var sl = document.getElementById('scanLine');
  function scan() {
    sl.style.top = (Math.random() * window.innerHeight) + 'px';
    sl.style.opacity = (0.3 + Math.random() * 0.5) + '';
    sl.style.transition = 'opacity 0.1s';
    setTimeout(function() {
      sl.style.opacity = '0';
      sl.style.transition = 'opacity 0.4s';
    }, 80 + Math.random() * 120);
    setTimeout(scan, 3000 + Math.random() * 8000);
  }
  setTimeout(scan, 2500);

  // --- MICRO GLITCH (JS-driven extra jitter) ---
  var base = document.getElementById('layerBase');
  function glitch() {
    if (Math.random() > 0.4) {
      var gx = (Math.random() - 0.5) * 14;
      var gy = (Math.random() - 0.5) * 4;
      base.style.transform = 'translate(' + gx + 'px,' + gy + 'px)';
      base.style.opacity = (0.5 + Math.random() * 0.4) + '';
      setTimeout(function() {
        base.style.transform = 'translate(0,0)';
        base.style.opacity = '1';
      }, 40 + Math.random() * 70);
    }
    setTimeout(glitch, 1500 + Math.random() * 4000);
  }
  setTimeout(glitch, 2500);

  // --- NOISE OSCILLATION ---
  var ni = 0.035, nd = 1;
  function osc() {
    ni += 0.001 * nd;
    if (ni > 0.06) nd = -1;
    if (ni < 0.02) nd = 1;
    nc.style.opacity = ni + '';
    requestAnimationFrame(osc);
  }
  requestAnimationFrame(osc);

  // --- BLUR MEMBRANE: thin band falling top to bottom, irregular timing ---
  var membrane = document.querySelector('.blur-membrane');
  var memY = -15; // start above viewport

  function dropMembrane() {
    // Reset to top
    memY = -15;
    membrane.style.transform = 'translateY(0vh)';
    membrane.style.opacity = '0';

    // Random delay before starting the fall (0.5s - 3s)
    var startDelay = 500 + Math.random() * 2500;

    setTimeout(function() {
      membrane.style.opacity = '1';
      // Fall speed: random duration 3s - 7s
      var fallDuration = 3000 + Math.random() * 4000;
      var startTime = performance.now();
      var startVh = -15;
      var endVh = 115; // past bottom

      function animateFall(now) {
        var elapsed = now - startTime;
        var progress = Math.min(elapsed / fallDuration, 1);
        // Ease: slight acceleration then deceleration
        var eased = progress < 0.5
          ? 2 * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 2) / 2;
        var currentVh = startVh + (endVh - startVh) * eased;
        membrane.style.transform = 'translateY(' + currentVh + 'vh)';

        // Fade in at start, fade out near end
        var opacity = 1;
        if (progress < 0.1) opacity = progress / 0.1;
        else if (progress > 0.85) opacity = (1 - progress) / 0.15;
        membrane.style.opacity = opacity.toString();

        if (progress < 1) {
          requestAnimationFrame(animateFall);
        } else {
          membrane.style.opacity = '0';
          // Random pause before next drop (1s - 5s)
          var pause = 1000 + Math.random() * 4000;
          setTimeout(dropMembrane, pause);
        }
      }
      requestAnimationFrame(animateFall);
    }, startDelay);
  }
  dropMembrane();

  // --- VIDEO CYCLING: 10 videos, shuffled order, hard cut, random blackouts ---
  var bgVideo = document.getElementById('bgVideo');

  // Build shuffled playlist (Fisher-Yates)
  var videoPool = [];
  function buildPlaylist() {
    videoPool = [
        'https://cdn.shopify.com/videos/c/o/v/5407aa8a31ad42608f1d9a77ef347c47.mp4',
        'https://cdn.shopify.com/videos/c/o/v/32a6c34694b84adf936996f95c17a939.mp4',
        'https://cdn.shopify.com/videos/c/o/v/55e3a08218cb4af0bc8fb3a6afd7a8a8.mp4',
        'https://cdn.shopify.com/videos/c/o/v/fe34c5be95364150bf380d075c2e3344.mp4',
        'https://cdn.shopify.com/videos/c/o/v/88fa7cb329504dea86626f4124191713.mp4',
        'https://cdn.shopify.com/videos/c/o/v/cf92025c43124225a4dc3bd5446d0384.mp4',
        'https://cdn.shopify.com/videos/c/o/v/24919698f94d4575bd171fe447a330d0.mp4',
        'https://cdn.shopify.com/videos/c/o/v/a223ecadffa34e51bcf65d1f07875c53.mp4',
        'https://cdn.shopify.com/videos/c/o/v/4a6c4891ae894b318714dc2352c1758d.mp4',
        'https://cdn.shopify.com/videos/c/o/v/fefe914463814432b21403d115ab3270.mp4'
    ];
    // シャッフル（Fisher-Yates）
    for (var j = videoPool.length - 1; j > 0; j--) {
        var k = Math.floor(Math.random() * (j + 1));
        var tmp = videoPool[j]; videoPool[j] = videoPool[k]; videoPool[k] = tmp;
    }
  }
  buildPlaylist();
  var videoIdx = 0;

  function playNextVideo() {
    // If playlist exhausted, reshuffle
    if (videoIdx >= videoPool.length) {
      buildPlaylist();
      videoIdx = 0;
    }

    // Hard cut: instantly show video
    bgVideo.src = videoPool[videoIdx];
    bgVideo.currentTime = 0;
    bgVideo.play().catch(function() {});
    bgVideo.style.opacity = '0.2';
    videoIdx++;

    // Play for 5-10 seconds
    var playDuration = 5000 + Math.random() * 5000;

    setTimeout(function() {
      // Hard cut to black
      bgVideo.style.opacity = '0';
      bgVideo.pause();

      // Random blackout gap (1-6 seconds)
      var gap = 1000 + Math.random() * 5000;
      setTimeout(playNextVideo, gap);
    }, playDuration);
  }

  // Start after load veil + random 5-10s delay
  var initialDelay = 5000 + Math.random() * 5000;
  setTimeout(playNextVideo, 1800 + initialDelay);

  // --- TOUCH ---
  document.addEventListener('touchmove', function(e) {
    if (e.touches.length) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; }
  }, { passive: true });

  // --- INSTAGRAM LINK: force window.open on mobile for reliability ---
  var igLink = document.getElementById('igLink');
  igLink.addEventListener('click', function(e) {
    e.preventDefault();
    window.open('https://www.instagram.com/celldivision_si/', '_blank', 'noopener,noreferrer');
  });
})();